import { gql } from '@apollo/client';

export default gql`
  mutation DeleteProductComponentBaseProductMutation(
    $productComponentBaseProductId: Int!
  ) {
    deleteProductComponentBaseProductById(
      input: { id: $productComponentBaseProductId }
    ) {
      productComponentBaseByProductComponentBaseId {
        id
      }
    }
  }
`;
